import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggle-categories"
// Toggles the "hidden-categories" class on the categories container when the trigger is clicked.
export default class extends Controller {
  static targets = ["categories"]

  toggle() {
    if (this.hasCategoriesTarget) {
      this.categoriesTarget.classList.toggle("hidden-categories")
    }
  }
}
